import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-watch-filled",
  "use": "icon-watch-filled-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" role=\"presentation\" id=\"icon-watch-filled\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M11.983 15.984a4.005 4.005 0 0 1-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 0 1 4.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8\" /><circle cx=\"12\" cy=\"12\" r=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol